import { render, staticRenderFns } from "./HomeSanDian5.vue?vue&type=template&id=5d2a0c54&scoped=true"
import script from "./HomeSanDian5.vue?vue&type=script&lang=js"
export * from "./HomeSanDian5.vue?vue&type=script&lang=js"
import style0 from "./HomeSanDian5.vue?vue&type=style&index=0&id=5d2a0c54&prod&scoped=true&lang=css"
import style1 from "./HomeSanDian5.vue?vue&type=style&index=1&id=5d2a0c54&prod&scoped=true&lang=css"
import style2 from "./HomeSanDian5.vue?vue&type=style&index=2&id=5d2a0c54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a0c54",
  null
  
)

export default component.exports